import { StyleProp, View, ViewStyle } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

type Props = {
  title: string;
  details?: string;
  detailsLeft?: React.ReactNode;
  style?: StyleProp<ViewStyle>;
};
export default function InfoText({
  title,
  details,
  detailsLeft,
  style,
}: Props) {
  const tailwind = useTailwind();

  return (
    <View style={style}>
      <Text variant="titleMedium">{title}</Text>
      {details && (
        <View style={tailwind("flex-row items-center gap-2")}>
          {detailsLeft}
          <Text variant="bodyMedium" style={tailwind("flex-1")}>
            {details}
          </Text>
        </View>
      )}
    </View>
  );
}
